import script from "./finallist.vue?vue&type=script&setup=true&lang=js"
export * from "./finallist.vue?vue&type=script&setup=true&lang=js"

import "./finallist.vue?vue&type=style&index=0&id=c572ea54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c572ea54"]])

export default __exports__